import { render } from "./PlayStore.vue?vue&type=template&id=df6beade"
import script from "./PlayStore.vue?vue&type=script&lang=js"
export * from "./PlayStore.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__